import { useStyledTable, useStyledTableProps } from '@/hooks/useStyledTable';
import DataTable, { DataTableProps } from '../ui/DataTable';

type StyledTableProps<TData, TValue> = useStyledTableProps<TData, TValue> &
  Omit<DataTableProps<TData>, 'table'>;

const StyledTable = <TData, TValue>({
  onRowClick,
  expandedNode,
  sorting,
  getRowId,
  isLoading,
  ...props
}: StyledTableProps<TData, TValue>) => {
  'use no memo';

  const table = useStyledTable({
    ...props,
    sorting,
    getRowId,
  });

  return (
    <DataTable
      table={table}
      onRowClick={onRowClick}
      expandedNode={expandedNode}
      sorting={sorting}
      isLoading={isLoading}
    />
  );
};

export default StyledTable;
